import React, { useEffect } from 'react'
import PropTypes from 'prop-types';
import styled from 'styled-components';
import modal from 'theme/modal';
import { StyledCloseModal, StyledModalV2, StyledModalContentV2, StyledModalOverlay } from 'styled/UI/StyledModal';
import Text from './Text';
import Icon from './Icon';

function ModalV2({
    children,
    isOpen,
    closeButton,
    isCircularClose,
    title,
    size,
    align,
    onClose,
    mobileSheet
}) {

    const onCloseClick = (e) => onClose(e || false);

    // Esc fecha e a página atrás para de rolar enquanto o modal está aberto.
    // Sem o segundo, rolar dentro do modal continuava a rolar a listagem por baixo.
    useEffect(() => {
        if (!isOpen) {
            return undefined;
        }

        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                onClose(false);
            }
        };

        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.body.style.overflow = previousOverflow;
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [isOpen, onClose]);

    return (
        isOpen && (
            <StyledModalOverlay
                size={size}
                mobileSheet={mobileSheet}
                onClick={(e) => onCloseClick(e)}
            >
                <StyledModalV2
                    size={size}
                    mobileSheet={mobileSheet}
                    role='dialog'
                    aria-modal='true'
                    onClick={(e) => e.stopPropagation()}
                >
                    {mobileSheet && (
                        <MobileSheetHandle />
                    )}
                    {closeButton && (
                        <StyledCloseModal circular={isCircularClose} onClick={(e) => onCloseClick(e)}>
                            <Icon name='close' />
                        </StyledCloseModal>
                    )}

                    {title && (
                        <Text name='highlight' marginBottom='12px'>
                            {title}
                        </Text>
                    )}
                    <StyledModalContentV2 textAlign={align}>
                        {children}
                    </StyledModalContentV2>
                </StyledModalV2>
            </StyledModalOverlay>
        )
    )
};

ModalV2.propTypes = {
    isOpen: PropTypes.bool,
    closeButton: PropTypes.bool,
    title: PropTypes.string,
    align: PropTypes.oneOf([...modal.align]),
    size: PropTypes.oneOf(['default', 'medium', 'large', 'xLarge']),
    onClose: PropTypes.func,
    mobileSheet: PropTypes.bool
};

ModalV2.defaultProps = {
    isOpen: false,
    closeButton: true,
    title: '',
    align: 'center',
    size: 'default',
    onClose: () => '',
    mobileSheet: false
};


const MobileSheetHandle = styled.div`
    width: 40px;
    height: 4px;
    border-radius: 2px;
    background: rgba(0, 0, 0, 0.2);
    margin: 10px auto 4px auto;
    flex-shrink: 0;
`;

export default ModalV2;